import {
  Component,
  OnInit,
  ViewEncapsulation,
  EventEmitter,
  Output,
  SecurityContext,
} from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { BehaviorSubject } from 'rxjs'
import { Router } from '@angular/router'
import { CheckoutService } from '../../checkout.service'
import { environment } from '../../../../../../../environments/environment'
import { CommonService } from '../../../../../../shared/services/common.service'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { share, take } from 'rxjs/operators'
import { Actions, ofType } from '@ngrx/effects'
import { DomSanitizer } from '@angular/platform-browser'
import { ActiveCartFacade, MultiCartFacade } from '@spartacus/cart/base/root'
import { OccCartAdapter } from '@spartacus/cart/base/occ'
import { CartActions } from '@spartacus/cart/base/core'
import { SpinnerOverlayService } from '../../../../../../shared/components/spinner-overlay/spinner-overlay.service'
import {
  DialogResponse,
  VS_LAUNCH_CALLER,
} from '../../../../../config/dialog.config'

import {
  Ecommerce,
  EcommerceItem,
  GTMCartType,
  GTMDataLayer,
} from '../../../../../../shared/models/googleTagManager.model';
import {
  ItemListTypeEnum,
  GtmEvents,
  StoreTypeEnum,
} from '../../../../../../shared/enums/gtm.enum';
import { GoogleTagManagerService } from '../../../../../../shared/services/gtm.service';

export const headerOptions = { responseType: 'text' as 'json' }

@Component({
  standalone: false,

  selector: 'vs-order-review-model',
  templateUrl: './order-review-model.component.html',
  styleUrls: ['./order-review-model.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OrderReviewModelComponent implements OnInit {
  public placeOrderData
  activeCart: any
  public cartId
  public orderObj
  public placeOrderCart
  public removeBtn = ''
  orderCode: any
  orderEmail: any
  public getPdf
  public pdfDownload
  quoteCartType: any
  rfqCartId: string
  quoteWSDTO: any
  public getErrorsFlag
  public isAdditionalType
  constructor(
    private launchDialogService: LaunchDialogService,
    private router: Router,
    private commonService: CommonService,
    protected activeCartService: ActiveCartFacade,
    private checkoutService: CheckoutService,
    protected multiCartService: MultiCartFacade,
    private occAdapter: OccCartAdapter,
    private spinnerOverlayService: SpinnerOverlayService,
    private actions$: Actions,
    private globalMessageService: GlobalMessageService,
    private domSanitizer: DomSanitizer,
    private gtmService: GoogleTagManagerService
  ) {
    this.rfqCartId = sessionStorage.getItem('cartId-current')
    this.launchDialogService.data$.subscribe((data) => {
      this.isAdditionalType = data.isAdditionalType
    })
    this.activeCartService.getActiveCartId().subscribe(
      (data) => {
        this.cartId = data
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    this.activeCartService.getActive().subscribe(
      (data) => {
        this.quoteCartType = data['quoteCartType']
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    /**
     * for quote conversion scenario
     */
    this.checkoutService.getCartReviewOrderResponse.subscribe(
      (response) => {
        this.quoteCartType = response['quoteCartType']
        this.quoteWSDTO = response
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  goToOrderConfirmation() {
    sessionStorage.setItem('itemNumber', '')
    this.router.navigate(['order-confirmation'])
  }
  goToOrderConfirmationWithError(value) {
    sessionStorage.setItem('itemNumber', '')
    this.router.navigate(['order-confirmation'], {
      queryParams: {
        value: 'true',
      },
    })
  }

  checkUpdateQuote() {
    const apiParam = ['users', 'current', 'vscart', this.cartId, 'updateQuote']

    const apiUrl = this.commonService.constructUrl(apiParam)
    this.spinnerOverlayService.show()
    this.commonService.getData_Text(apiUrl).subscribe(
      (success) => {
        if (success == 'SUBMITTED') {
          this.spinnerOverlayService.hide()
          this.quoteToOrder()
        } else if (success == 'FAILEDTOSUBMIT') {
          this.checkoutService.storePlaceOrderStatus.next(true)
          this.occAdapter
            .create('current')
            .pipe(take(1))
            .subscribe((occData: any) => {
              const buyCartId = occData.code
              this.multiCartService.loadCart({
                userId: 'current',
                cartId: buyCartId,
                extraData: {
                  active: true,
                },
              })
              this.actions$
                .pipe(ofType(CartActions.LOAD_CART_SUCCESS), take(1))
                .subscribe(
                  (res) => {
                    this.spinnerOverlayService.hide()
                    this.goToOrderConfirmationWithError('true')
                  },
                  (error) => {
                    this.spinnerOverlayService.hide()
                    this.globalMessageService.add(
                      error,
                      GlobalMessageType.MSG_TYPE_ERROR,
                      5000
                    )
                    window.scrollTo(0, 0)
                  }
                )
            })
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  quoteToOrder() {
    let rfqTypeData
    rfqTypeData = sessionStorage.getItem('itemNumber')
    this.spinnerOverlayService.show()
    const apiParam = [
      'users',
      'current',
      'rfqcart',
      this.cartId,
      'quoteToOrders',
    ]
    const apiUrl = this.commonService.constructUrl(apiParam)
    this.quoteWSDTO.rfqType = rfqTypeData
    this.commonService.postData(apiUrl, this.quoteWSDTO).subscribe(
      (success) => {
        this.placeOrderData = success
        this.orderCode = success['code']
        this.orderEmail = success['notificationEmail']
        this.placeOrderData.code = this.orderCode
        //  this.checkoutService.sendOrderId(this.orderCode);
        this.checkoutService.storeOrderId.next(this.orderCode)
        this.placeOrderData.notificationEmail = this.orderEmail
        sessionStorage.setItem('orderCode', this.orderCode)
        sessionStorage.setItem('orderNotificationEmail', this.orderEmail)
        //   this.checkoutService.sendOrderEmail(this.orderEmail);
        this.checkoutService.storeOrderEmail.next(this.orderEmail)
        this.checkoutService.storePlaceOrderStatus.next(true)

        this.gtmPurchaseEvent(GtmEvents.Purchase, GTMCartType.QUOTE_TO_ORDER);

        this.occAdapter
          .create('current')
          .pipe(take(1))
          .subscribe((occData: any) => {
            const buyCartId = occData.code
            this.multiCartService.loadCart({
              userId: 'current',
              cartId: buyCartId,
              extraData: {
                active: true,
              },
            })
            this.actions$
              .pipe(ofType(CartActions.LOAD_CART_SUCCESS), take(1))
              .subscribe(
                (res) => {
                  this.spinnerOverlayService.hide()
                  this.goToOrderConfirmation()
                },
                (error) => {
                  this.spinnerOverlayService.hide()
                  this.globalMessageService.add(
                    error,
                    GlobalMessageType.MSG_TYPE_ERROR,
                    5000
                  )
                  window.scrollTo(0, 0)
                }
              )
          })
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  postPlaceOrderDetails() {
    this.removeBtn = ''

    if (this.isAdditionalType) {
      this.checkUpdateQuote()
    } else if (this.quoteCartType) {
      this.quoteToOrder()
    } else {
      this.checkoutService.inOrderFlowOnly.next(true)
      const apiParam = ['users', 'current', 'vsOrders']
      const apiUrl =
        this.commonService.constructUrl(apiParam) +
        '?cartId=' +
        this.cartId +
        ''
      this.spinnerOverlayService.show()

      this.commonService
        .postData(apiUrl, this.cartId)
        .pipe(share())
        .subscribe(
          (success) => {
            this.placeOrderData = success
            this.orderCode = success['code']
            this.orderEmail = success['notificationEmail']
            this.placeOrderData.code = this.orderCode
            this.placeOrderData.notificationEmail = this.orderEmail
            //  this.checkoutService.sendOrderId(this.orderCode);
            this.checkoutService.storeOrderId.next(this.orderCode)
            this.checkoutService.storeOrderEmail.next(this.orderEmail)
            sessionStorage.setItem('orderCode', this.orderCode)
            sessionStorage.setItem('orderNotificationEmail', this.orderEmail)
            this.checkoutService.storePlaceOrderStatus.next(true)
            // this.checkoutService.sendOrderEmail(this.orderEmail);
            /**
             * Code block to update Cart data on frontend
             */
            this.gtmPurchaseEvent(GtmEvents.Purchase, GTMCartType.BUY_CART);

            this.occAdapter
              .create('current')
              .pipe(take(1))
              .subscribe((occData: any) => {
                const buyCartId = occData.code
                this.multiCartService.loadCart({
                  userId: 'current',
                  cartId: buyCartId,
                  extraData: {
                    active: true,
                  },
                })
                this.actions$
                  .pipe(ofType(CartActions.LOAD_CART_SUCCESS), take(1))
                  .subscribe((res) => {
                    this.spinnerOverlayService.hide()

                    this.checkoutService.inOrderFlowOnly.subscribe((status) => {
                      if (status) {
                        this.checkoutService.inOrderFlowOnly.next(false)
                        this.goToOrderConfirmation()
                      }
                    })
                  })
              })
          },
          (error) => {
            this.spinnerOverlayService.hide()
            this.globalMessageService.add(
              error,
              GlobalMessageType.MSG_TYPE_ERROR,
              5000
            )
            window.scrollTo(0, 0)
          }
        )
    }
  }

  getPDFDownload(cartId) {
    const apiParam = [
      'users',
      'current',
      'vscart',
      cartId,
      'getTermsAndConditions',
    ]
    const apiUrl = this.commonService.constructUrl(apiParam)
    this.commonService.getData(apiUrl).subscribe(
      (success) => {
        this.pdfDownload = success
        this.getPdf = this.pdfDownload.associatedPdf
        let downPdf = this.getPdf[0].downloadUrl
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  ngOnInit(): void {
    this.checkoutService.recieveErrFlag.subscribe(
      (success) => {
        this.getErrorsFlag = success
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    this.getPDFDownload(this.cartId)
  }

  dismissModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.ORDER_REVIEW,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }

  constructURL(pdfdownload) {
    // return this.commonService.constructUrl([pdfdownload.downloadUrl]);
    const preUrl = environment.occBaseUrl // + environment.occPrefix + environment.occBaseSite;
    return this.domSanitizer.sanitize(
      SecurityContext.URL,
      preUrl + pdfdownload.downloadUrl
    )
  }

  gtmPurchaseEvent(gtmevent, cartType) {
    this.gtmService.sendEvent({
      ecommerce: null,
      event: 'ecommerce_clear'
    });

    let productItems: EcommerceItem[] = [];

    this.quoteWSDTO?.entries.forEach((item, i) => {
      let eachitem: EcommerceItem = {
        item_id: item?.product?.code,
        item_name: item?.product?.name,
        index: i,
        item_list_id: ItemListTypeEnum.Cart,
        item_list_name: ItemListTypeEnum.Cart,
        price: item?.netPrice?.value,
        quantity: item?.quantity || 1,
      };
      productItems.push(eachitem);
    });

    let purchaseEcommerceEcommerce: Ecommerce = {
      transaction_id: this.orderCode,
      value: this.quoteWSDTO?.totalPrice.value,
      tax: this.quoteWSDTO?.totalTax.value,
      currency: this.quoteWSDTO?.totalPrice?.currencyIso,
      items: productItems,
    };
    let purchaseDataLayer: GTMDataLayer = {
      event: gtmevent,
      ecommerce: purchaseEcommerceEcommerce,
      commerceType: cartType,
      cart_id: this.cartId
    };

    this.gtmService.sendEvent(purchaseDataLayer);
  }
}
